import { Tooltip } from "antd";
import React, { useState } from "react";

const GeneralComplianceCard = ({ data }) => {
    const [expandedIndex, setExpandedIndex] = useState(null); // 👈 track which card is open


    const renderSummary = (summary, index) => {
        if (!summary) return null;
        const isLong = summary.length > 100;
        const isExpanded = expandedIndex === index;

        const displayText = isExpanded
            ? summary
            : summary.substring(0, 100) + (isLong ? "..." : "");

        return (
            <>
                <p className="text-sm">{displayText}</p>
                {isLong && (
                    <button
                        type="button"
                        onClick={() =>
                            setExpandedIndex(isExpanded ? null : index) // 👈 toggle one at a time
                        }
                        className="text-blue-600 text-sm font-medium hover:underline mt-1"
                    >
                        {isExpanded ? "Read less" : "Read more"}
                    </button>
                )}
            </>
        );
    };

    return (
        <div className="w-full flex flex-col items-center justify-start gap-2">
            <div className="w-full grid grid-cols-1 md:grid-cols-3 items-stretch gap-5 text-wrap">
                {data.map((item, index) => (
                    <div
                        key={item.code || index}
                        className="border rounded-xl p-3 flex flex-col gap-2 shadow-lg hover:shadow-2xl h-full transition-all"
                    >
                        <div className="flex justify-between items-start border-b pb-2 mb-2">
                            <div className="flex items-center justify-between font-medium w-full">
                                <div className="flex flex-col font-semibold pl-2">
                                    {item?.new_label?.length > 40 ? (
                                        <Tooltip title={item.new_label}>

                                            <span>{item.new_label.slice(0, 40) + "..."}</span>
                                        </Tooltip>
                                    ) : (

                                        <span>{item.new_label}</span>
                                    )}
                                    <span className="text-xs text-gray-500">{item.exception}</span>
                                </div>
                                <div className="w-fit flex justify-end">

                                    <div className="px-4 py-2 text-sm font-semibold text-nowrap rounded-lg bg-gradient-to-r text-white from-neutral-500 to-neutral-500/40 shine">
                                        {item.ab_label}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="w-full border shadow-lg flex h-full flex-col items-start justify-start p-4 rounded-lg col-span-2">
                            <p className="font-semibold">Information</p>
                            {renderSummary(item.new_content, index)}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default GeneralComplianceCard;
